import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0d1117] shadow-lg' : 'bg-transparent backdrop-blur-md'
      }`}
      style={{ height: '80px' }}
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 h-full flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center gap-3">
          <img 
            src="https://public.readdy.ai/ai/img_res/d0bddc9b-861e-48e2-8161-fe8ee0c179e9.png" 
            alt="Dark Warrior Weapons" 
            className="h-10 w-10 sm:h-12 sm:w-12 object-contain"
          />
          <span className="text-[#8B6914] font-bold text-lg sm:text-xl tracking-wider">DWW</span>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden lg:flex items-center gap-12">
          <button
            onClick={() => scrollToSection('home')}
            className="text-sm uppercase tracking-wide text-gray-300 hover:text-[#8B6914] transition-colors relative group whitespace-nowrap cursor-pointer"
          >
            HOME
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#8B6914] group-hover:w-full transition-all duration-300"></span>
          </button>
          <button
            onClick={() => scrollToSection('products')}
            className="text-sm uppercase tracking-wide text-gray-300 hover:text-[#8B6914] transition-colors relative group whitespace-nowrap cursor-pointer"
          >
            ARSENAL
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#8B6914] group-hover:w-full transition-all duration-300"></span>
          </button>
          <button
            onClick={() => scrollToSection('craftsmanship')}
            className="text-sm uppercase tracking-wide text-gray-300 hover:text-[#8B6914] transition-colors relative group whitespace-nowrap cursor-pointer"
          >
            CRAFT
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#8B6914] group-hover:w-full transition-all duration-300"></span>
          </button>
          <button
            onClick={() => scrollToSection('about')}
            className="text-sm uppercase tracking-wide text-gray-300 hover:text-[#8B6914] transition-colors relative group whitespace-nowrap cursor-pointer"
          >
            STORY
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#8B6914] group-hover:w-full transition-all duration-300"></span>
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className="text-sm uppercase tracking-wide text-gray-300 hover:text-[#8B6914] transition-colors relative group whitespace-nowrap cursor-pointer"
          >
            CONTACT
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#8B6914] group-hover:w-full transition-all duration-300"></span>
          </button>
        </div>

        {/* Desktop CTA Button */}
        <div className="hidden lg:flex items-center gap-4">
          <button
            onClick={() => scrollToSection('products')}
            className="bg-[#8B6914] text-white px-6 py-3 rounded-xl text-sm font-semibold hover:bg-[#6B4423] transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            ENTER THE ARMORY
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="lg:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
        >
          <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden absolute top-[80px] left-0 right-0 bg-[#0d1117] border-t border-gray-800 shadow-xl">
          <div className="px-4 py-6 space-y-4">
            <button
              onClick={() => scrollToSection('home')}
              className="block w-full text-left text-base uppercase tracking-wide text-gray-300 hover:text-[#8B6914] transition-colors py-3 cursor-pointer"
            >
              HOME
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className="block w-full text-left text-base uppercase tracking-wide text-gray-300 hover:text-[#8B6914] transition-colors py-3 cursor-pointer"
            >
              ARSENAL
            </button>
            <button
              onClick={() => scrollToSection('craftsmanship')}
              className="block w-full text-left text-base uppercase tracking-wide text-gray-300 hover:text-[#8B6914] transition-colors py-3 cursor-pointer"
            >
              CRAFT
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left text-base uppercase tracking-wide text-gray-300 hover:text-[#8B6914] transition-colors py-3 cursor-pointer"
            >
              STORY
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left text-base uppercase tracking-wide text-gray-300 hover:text-[#8B6914] transition-colors py-3 cursor-pointer"
            >
              CONTACT
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className="w-full bg-[#8B6914] text-white px-6 py-4 rounded-xl text-base font-semibold hover:bg-[#6B4423] transition-all flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer mt-4"
            >
              ENTER THE ARMORY
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
